/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $ListCompanyMatchBypassResponse = {
  type: 'all-of',
  contains: [{
    type: 'Response',
  }, {
    properties: {
      data: {
        type: 'array',
        contains: {
          type: 'CompanyMatchBypass',
        },
      },
    },
  }],
} as const;
